var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
var MyModel = /** @class */ (function (_super) {
    __extends(MyModel, _super);
    function MyModel(root) {
        return _super.call(this, "/api/users", root, {}) || this;
    }
    MyModel.prototype.onViewModelSetting = function (d) {
        if (!d.data) {
            d.data = { nickname: "", age: 0 };
        }
        return Promise.resolve(false);
    };
    MyModel.prototype.onValidating = function (d) {
        var fs = this.container.querySelectorAll(".create__form .input");
        for (var i = 0; i < fs.length; i++) {
            var f = fs[i];
            if (!f.validity.valid) {
                return (f.getAttribute("data-validation-message"));
            }
        }
        return "";
    };
    MyModel.prototype.save = function () {
        _super.prototype.saveData.call(this, this.viewModel().data)
            .then(function (d) {
            if (d === false)
                return;
            return window.popBox.show("操作成功。")
                .then(function () { return history.go(-1); });
        });
    };
    return MyModel;
}(KnockoutModel));
var MyViewModel = /** @class */ (function (_super) {
    __extends(MyViewModel, _super);
    function MyViewModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyViewModel.prototype.init = function () {
        this.c = new MyModel(this.container);
    };
    MyViewModel.prototype.update = function (arg) {
        this.c.id = arg.routeData.id;
        return this.c.loadData();
    };
    MyViewModel.prototype.onInitComplete = function () {
    };
    return MyViewModel;
}(Page));
export default MyViewModel;
